import { Box, useBreakpointValue } from '@chakra-ui/react';
import { MdChat as ChatIcon } from 'react-icons/md';
import { useAuth } from '@/hooks/useAuth';
import { useChatContext } from '@/hooks/useChatContext';

interface FloatingAIChefButtonProps {
  recipeId?: string;
  collectionId?: string;
}

export default function FloatingAIChefButton({ recipeId, collectionId }: FloatingAIChefButtonProps) {
  const { user } = useAuth();
  const { openChat } = useChatContext();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  // On mobile the BottomNavBar owns AI Chef — this button is desktop-only.
  if (!user || isMobile) return null;

  const handleClick = () => {
    openChat({ recipeId: recipeId ?? null, collectionId: collectionId ?? null });
  };

  return (
    <Box
      position="fixed"
      bottom="24px"
      right="24px"
      w="52px"
      h="52px"
      borderRadius="15px"
      bg="accent.secondary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onClick={handleClick}
      role="button"
      aria-label="Chat with AI Chef"
      zIndex={9999}
      transition="background 0.15s, transform 0.15s"
      _hover={{ bg: 'accent.secondaryHover', transform: 'translateY(-2px)' }}
    >
      <ChatIcon size={22} color="white" />
    </Box>
  );
}
